import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoganpatipune() {



    const cardData = {

keyword: "Pune to Ganpatipule Taxi",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Ganpatipule Taxi services for families, couples, and coastal travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance journey from Pune to the Konkan coast. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxed and enjoyable travel experience to Ganpatipule beach and temple town.",

topPlaces: [
    {
        title: "Ganpatipule Beach",
        description:
            "Ganpatipule Beach is a pristine and clean coastline on the Konkan coast known for its white sand, clear waters, and peaceful environment. It is ideal for relaxation, sunset views, and long peaceful walks along the shore."
    },
    {
        title: "Swayambhu Ganpati Temple",
        description:
            "Swayambhu Ganpati Temple is a 400-year-old self-manifested Lord Ganesha temple located right on the beach. It is a major pilgrimage site attracting devotees and tourists for its spiritual significance and scenic surroundings."
    },
    {
        title: "Malgund Village",
        description:
            "Malgund is the birthplace of famous Marathi poet Kavi Keshavsoot and is located near Ganpatipule. The village offers cultural heritage, local Konkan lifestyle, and peaceful surroundings."
    },
    {
        title: "Jaigad Fort",
        description:
            "Jaigad Fort is a historic sea fort located at the mouth of the Shastri River overlooking the Arabian Sea. It offers stunning coastal views and is a popular sightseeing spot near Ganpatipule."
    },
    {
        title: "Jaigad Lighthouse",
        description:
            "Jaigad Lighthouse is located near Jaigad Fort and provides panoramic views of the Arabian Sea and surrounding coastline, making it a great photography and sightseeing point."
    },
    {
        title: "Pawas (Swami Swaroopanand Ashram)",
        description:
            "Pawas is a peaceful spiritual destination near Ratnagiri known for Swami Swaroopanand Ashram. It attracts devotees seeking meditation, peace, and spiritual learning."
    },
    {
        title: "Ratnagiri City Beaches",
        description:
            "Ratnagiri, located near Ganpatipule, is known for its clean beaches, seafood, and scenic Konkan coastline, making it a popular stop during coastal cab journeys."
    },
    {
        title: "Aare Ware Beach",
        description:
            "Aare Ware Beach is a twin beach stretch near Ganpatipule known for its untouched beauty, clean shoreline, and less crowded peaceful environment, ideal for nature lovers."
    },
    {
        title: "Marleshwar Waterfall Temple",
        description:
            "Marleshwar is a unique cave temple dedicated to Lord Shiva located near a waterfall in the Sahyadri hills. It combines spirituality with natural beauty and is a popular stop on Konkan routes."
    },
    {
        title: "Konkan Coastal Drive Route",
        description:
            "The Pune to Ganpatipule route passes through scenic Western Ghats and Konkan highways, offering lush greenery, mountain views, and coastal landscapes, making the cab journey itself highly enjoyable."
    }
],



services: [
  {
    name: "Pune to Ganpatipule Cab",
    description: "Rising Cab Service offers premium Pune to Ganpatipule Cab service for a safe, comfortable, and scenic Konkan coastal journey. Our service is designed for families, couples, and groups who want a stress-free beach and temple trip. We provide well-maintained AC vehicles, experienced long-distance drivers, doorstep pickup from Pune, flexible travel timings, and 24x7 booking support. Whether it is a weekend getaway, holiday trip, or pilgrimage visit to Ganpatipule Temple, we ensure smooth highway driving, coastal route comfort, and a fully enjoyable travel experience with transparent pricing and no hidden charges."
  },
  {
    name: "Pune to Ganpatipule Taxi",
    description: "Book Pune to Ganpatipule Taxi with Rising Cab Service for a reliable and comfortable long-distance journey to the beautiful Konkan coastline. Our taxis are perfect for beach vacations, temple darshan trips, and family tours. We offer clean AC cars, professional chauffeurs, flexible pickup and drop options, and safe driving through highway and ghat routes. Enjoy a peaceful ride with real-time assistance, affordable pricing, and a smooth travel experience from Pune to Ganpatipule."
  },
  {
    name: "Cab from Pune to Ganpatipule",
    description: "Hire Cab from Pune to Ganpatipule for a convenient door-to-door travel experience to one of Maharashtra’s most scenic beach destinations. Our service includes comfortable sedans, SUVs, and Innova Crysta options for all group sizes. With trained drivers experienced in long coastal routes, you can enjoy a safe, relaxed, and enjoyable journey with stops for sightseeing, food breaks, and photo points along the way."
  },
  {
    name: "Taxi from Pune to Ganpatipule",
    description: "Taxi from Pune to Ganpatipule service by Rising Cab Service ensures a smooth and hassle-free ride for tourists and pilgrims. We provide punctual pickup, sanitized vehicles, and professional drivers who prioritize safety and comfort. Ideal for weekend trips, family vacations, and spiritual visits, our taxis offer flexible scheduling, affordable packages, and a comfortable journey through scenic Konkan routes."
  },
  {
    name: "Pune to Ganpatipule Cab Service",
    description: "Our Pune to Ganpatipule Cab Service is designed for travelers looking for a complete travel solution including pickup, drop, sightseeing flexibility, and return options. We offer 24x7 availability, well-maintained cars, experienced chauffeurs, and customized travel plans for beach tours and temple visits. Enjoy a safe, comfortable, and memorable journey with complete travel assistance."
  },
  {
    name: "Pune to Ganpatipule Taxi Fare",
    description: "Get transparent Pune to Ganpatipule Taxi Fare with Rising Cab Service, designed to offer affordable and clear pricing based on vehicle type and travel plan. We provide budget-friendly and premium options for sedans, SUVs, and Innova Crysta with no hidden charges. Our fare structure ensures value for money while maintaining comfort, safety, and long-distance travel quality."
  },
  {
    name: "Pune to Ganpatipule One Way Cab",
    description: "Book Pune to Ganpatipule One Way Cab for drop-only travel at the most economical rates. Ideal for solo travelers, couples, and families relocating or planning one-way trips, this service includes AC vehicles, professional drivers, and smooth coastal highway travel. Save on return charges while enjoying a safe and comfortable ride."
  },
  {
    name: "Pune to Ganpatipule Round Trip Taxi",
    description: "Pune to Ganpatipule Round Trip Taxi service is perfect for weekend getaways and holiday tours with flexible return scheduling. We provide waiting time options, comfortable vehicles, and experienced drivers who ensure smooth travel both ways. Enjoy a relaxed beach vacation with complete travel convenience."
  },
  {
    name: "Pune to Ganpatipule Cab Booking",
    description: "Easy Pune to Ganpatipule Cab Booking system for instant reservations with multiple vehicle options including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support for a seamless travel experience from Pune to Ganpatipule."
  },
  {
    name: "Cheap Pune to Ganpatipule Cab",
    description: "Affordable Cheap Pune to Ganpatipule Cab service for budget travelers who want economical yet safe long-distance travel. We offer low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety, making your Konkan trip accessible and enjoyable."
  },
  {
    name: "Best Pune to Ganpatipule Taxi",
    description: "Choose Best Pune to Ganpatipule Taxi service for a premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving. We ensure high-quality service, punctuality, and complete customer satisfaction for your beach or temple trip."
  },
  {
    name: "Sedan Pune to Ganpatipule Cab",
    description: "Sedan Pune to Ganpatipule Cab service is ideal for solo travelers, couples, and small families looking for comfortable and budget-friendly travel. Enjoy fuel-efficient cars, smooth rides, and professional drivers for a safe journey to the Konkan coast."
  },
  {
    name: "SUV Pune to Ganpatipule Taxi",
    description: "Book SUV Pune to Ganpatipule Taxi for group travel and long-distance comfort. Our SUVs offer extra space, strong road performance, and smooth suspension for ghat and coastal roads, making them perfect for family vacations."
  },
  {
    name: "Innova Pune to Ganpatipule Cab",
    description: "Premium Innova Pune to Ganpatipule Cab service for families and groups seeking extra comfort and luxury. Enjoy spacious seating, smooth travel experience, and experienced drivers for long scenic coastal journeys."
  },
  {
    name: "Beach Cab Pune Ganpatipule",
    description: "Beach Cab Pune Ganpatipule service is specially designed for tourists visiting Ganpatipule Beach. Enjoy scenic coastal drives, flexible stops, and comfortable AC vehicles for a relaxing beach holiday experience."
  },
  {
    name: "Ganpatipule Cab from Pune",
    description: "Ganpatipule Cab from Pune service offers direct and comfortable travel to the famous beach and temple destination. We provide door-to-door pickup, safe driving, and flexible travel plans for families and groups."
  },
  {
    name: "Pune to Ganpatipule Beach Cab",
    description: "Pune to Ganpatipule Beach Cab service ensures a smooth and scenic coastal journey with professional drivers and comfortable vehicles, perfect for holiday and weekend trips."
  },
  {
    name: "Pune to Ganpatipule Konkan Tour Cab",
    description: "Pune to Ganpatipule Konkan Tour Cab service offers complete travel packages covering beaches, temples, and scenic Konkan routes with flexible itineraries and comfortable rides."
  },
  {
    name: "Pune to Ganpatipule Darshan Cab",
    description: "Pune to Ganpatipule Darshan Cab service is designed for temple visitors, ensuring safe and peaceful travel to Ganpatipule Temple with experienced drivers and smooth routes."
  },
  {
    name: "Pune to Ganpatipule Innova Taxi",
    description: "Pune to Ganpatipule Innova Taxi service offers premium comfort for long coastal journeys with spacious seating and smooth driving experience for families and groups."
  },
  {
    name: "Pune to Ganpatipule Tourist Cab Service",
    description: "Pune to Ganpatipule Tourist Cab Service provides complete travel solutions for sightseeing, beach visits, and temple darshan with professional drivers and flexible packages."
  },
  {
    name: "Pune to Ganpatipule Travel Package",
    description: "Pune to Ganpatipule Travel Package includes pickup, sightseeing, beach visits, and return journey for a complete and hassle-free travel experience."
  },
  {
    name: "Pune to Ganpatipule Long Distance Cab",
    description: "Pune to Ganpatipule Long Distance Cab service ensures safe, comfortable, and reliable highway travel with experienced drivers and well-maintained vehicles."
  },
  {
    name: "Pune to Ganpatipule Door to Door Taxi",
    description: "Pune to Ganpatipule Door to Door Taxi service offers convenient pickup and drop from your location, ensuring maximum comfort and time-saving travel."
  },
  {
    name: "Pune to Ganpatipule Temple Cab",
    description: "Pune to Ganpatipule Temple Cab service provides smooth and peaceful travel for devotees visiting Ganpatipule Temple with reliable drivers and AC vehicles."
  },
  {
    name: "Ganpatipule Beach Cab from Pune",
    description: "Ganpatipule Beach Cab from Pune service ensures a scenic and relaxing journey to the beach with comfortable seating and safe driving."
  },
  {
    name: "Pune to Ganpatipule Temple Darshan Cab",
    description: "Pune to Ganpatipule Temple Darshan Cab service is designed for pilgrims seeking a comfortable and timely visit to Ganpatipule Temple with hassle-free travel."
  }
],

tableData: [
  ["Pune to Ganpatipule Cab", "Pune to Ganpatipule Taxi"],
  ["Cab from Pune to Ganpatipule", "Taxi from Pune to Ganpatipule"],
  ["Pune to Ganpatipule Cab Service", "Pune to Ganpatipule Taxi Fare"],
  ["Pune to Ganpatipule One Way Cab", "Pune to Ganpatipule Round Trip Taxi"],
  ["Pune to Ganpatipule Cab Booking", "Cheap Pune to Ganpatipule Cab"],
  ["Best Pune to Ganpatipule Taxi", "Sedan Pune to Ganpatipule Cab"],
  ["SUV Pune to Ganpatipule Taxi", "Innova Pune to Ganpatipule Cab"],
  ["Beach Cab Pune Ganpatipule", "Ganpatipule Cab from Pune"],
  ["Pune to Ganpatipule Konkan Tour Cab", "Pune to Ganpatipule Travel Package"],
  ["Pune to Ganpatipule Door to Door Taxi", "Pune to Ganpatipule Temple Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Ganpatipule Taxi Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Ganpatipule taxi transportation for families, tourists, couples, pilgrims, and beach holiday travelers."
    },
    {
        WhyChooseheading: "Perfect for Konkan Beach Vacations",
        WhyChoosedescription: "Ganpatipule is one of Maharashtra's most popular coastal destinations, known for its pristine beaches, scenic beauty, and famous Ganpati Temple."
    },
    {
        WhyChooseheading: "Ideal for Family Holidays and Weekend Trips",
        WhyChoosedescription: "Whether planning a beach vacation, family outing, honeymoon trip, temple visit, or Konkan tour, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Choices",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for every travel requirement."
    },
    {
        WhyChooseheading: "Explore Ganpatipule and Nearby Attractions",
        WhyChoosedescription: "Travelers can conveniently visit Ganpatipule Temple, Ganpatipule Beach, Prachin Konkan Museum, Ratnagiri, Aare Ware Beach, and surrounding tourist destinations."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Comfortable Konkan Road Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Konkan routes and ensure a smooth, safe, and enjoyable travel experience."
    },
    {
        WhyChooseheading: "Customized One-Way and Round Trip Packages",
        WhyChoosedescription: "Customers can choose one-way transfers, return journeys, weekend packages, multi-day tours, and personalized Konkan travel plans."
    }
]
};

const faqData = [
    {
        question: "Why is Ganpatipule a popular tourist destination?",
        answer: "Ganpatipule is famous for its self-manifested Ganpati Temple, beautiful beaches, coastal landscapes, and peaceful atmosphere."
    },
    {
        question: "Can I book a one-way taxi from Pune to Ganpatipule?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which attractions can be visited in Ganpatipule?",
        answer: "Popular attractions include Ganpatipule Temple, Ganpatipule Beach, Aare Ware Beach, Prachin Konkan Museum, Ratnadurg Fort, and Ratnagiri sightseeing spots."
    },
    {
        question: "Which vehicle is suitable for a family trip to Ganpatipule?",
        answer: "Ertiga and Innova Crysta are commonly preferred because they provide comfortable seating and ample luggage space."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can Ganpatipule and Ratnagiri be covered in one trip?",
        answer: "Yes, customized itineraries can include Ganpatipule, Ratnagiri, Aare Ware Beach, Pawas, and other Konkan attractions."
    },
    {
        question: "Are weekend tour packages available for Ganpatipule?",
        answer: "Yes, customers can choose weekend holiday packages, overnight stays, and multi-day Konkan tours."
    },
    {
        question: "Can the taxi be arranged for temple darshan and sightseeing together?",
        answer: "Yes, travel plans can include both Ganpatipule Temple Darshan and local sightseeing attractions."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune to Ganpatipule Taxi?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pravin Sawant",
        feedback:
            "Our Konkan vacation became unforgettable thanks to the comfortable travel arrangements. The journey to Ganpatipule was smooth, and the vehicle was maintained exceptionally well.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shilpa Patankar",
        feedback:
            "The family trip to Ganpatipule was planned perfectly. We visited the temple, explored nearby beaches, and enjoyed a relaxed journey throughout the tour.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ganpatipule Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ganpatipule-cab.jpg",
"description": "Book Pune to Ganpatipule Taxi Service with Rising Cab Service for safe and comfortable coastal travel and temple visit. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars at affordable rates.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ganpatipule-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Ganpatipule Taxi Service | Coastal Temple Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ganpatipule Taxi Service for safe and comfortable coastal and temple travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to ganpatipule cab, pune to ganpatipule taxi, cab from pune to ganpatipule, taxi from pune to ganpatipule, pune to ganpatipule cab service, pune to ganpatipule taxi fare, pune to ganpatipule one way cab, pune to ganpatipule round trip taxi, pune to ganpatipule cab booking, cheap pune to ganpatipule cab, best pune to ganpatipule taxi, sedan pune to ganpatipule cab, suv pune to ganpatipule taxi, ganpatipule temple cab pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoganpatipune;